import * as React from "react";
import { IconButton, Tooltip } from "@mui/material";
import {ReactComponent as ReloadIcon} from "../../../../statics/icons/icon_reload.svg";
import "./reloadButton.scss";
import i18n from "../../../../i18n/i18n";

interface ReloadButtonProps {
    reloadFunc: () => void;
    testId?: string;
    className?: string;
}

export default function ReloadButton(props: ReloadButtonProps): React.ReactElement {
    return (
        <Tooltip title={i18n.t("reloadMessage").toString()} arrow>
            <IconButton
                className={`reload-btn ${props.className}`}
                onClick={props.reloadFunc}
                data-testid={props.testId}
            >
                <ReloadIcon/>
            </IconButton>
        </Tooltip>
    );
}
